import {
    DASHBOARD_PANEL_GADGET_CHART_DRIVER_GROUP,
    DASHBOARD_PANEL_GADGET_CHART_DRIVER_GROUP_RESPONSE,
    DASHBOARD_PANEL_GADGET_CHART_DATA,
    DASHBOARD_PANEL_GADGET_CHART_DATA_RESPONSE,
    DASHBOARD_PANEL_SEARCH_DEVELOPERS_REQUEST,
    DASHBOARD_PANEL_SEARCH_DEVELOPERS_RESULT,
} from "Redux/actionTypes";

export const driverGroupChartPanel = (data) => ({
    type: DASHBOARD_PANEL_GADGET_CHART_DRIVER_GROUP,
    payload: {},
})

export const driverGroupChartPanelResponse = (data) => ({
    type: DASHBOARD_PANEL_GADGET_CHART_DRIVER_GROUP_RESPONSE,
    payload: data,
})

export const chartDashboardPanel = (data) => ({
    type: DASHBOARD_PANEL_GADGET_CHART_DATA,
    payload: { data },
});

export const chartDashboardPanelResponse = (data) => ({
    type: DASHBOARD_PANEL_GADGET_CHART_DATA_RESPONSE,
    payload: data,
});

export const chartDashboardPanelSearchDevelopersRequest = (data) => ({
    type: DASHBOARD_PANEL_SEARCH_DEVELOPERS_REQUEST,
    payload: data,
});

export const chartDashboardPanelSearchDevelopersResult = (data) => ({
    type: DASHBOARD_PANEL_SEARCH_DEVELOPERS_RESULT,
    payload: data,
});